export default {
      id: "arrow-left-usage",
      viewBox: "0 0 20 10",
      url: __webpack_public_path__ + "img/icons.e748fd75.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }